import React from 'react'
import Modal from '../../modal'
import CloseSVG from '../../../../assets/svg/close.svg'
import { formatNewDateInWords } from '../../../../utils/functions'

const ViewPerformance = ({ closeModal, isOpen, assessmentData, data }) => {
  return (
    <>
      <Modal
        scrollable={true}
        className='!max-w-[600px] !min-w-[600px] !rounded-none'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto'>
          <div className='pl-6 pr-6 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>
                {assessmentData?.first_name} {assessmentData?.last_name}{' '}
                Evaluation
              </span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider mb-2' />
          <h1 className='font-semibold text-base text-[#000005] px-3'>
            Evaluation period:{' '}
            <span className='text-green-600'>
              {formatNewDateInWords(assessmentData.evaluation_start)} -{' '}
              {formatNewDateInWords(assessmentData.evaluation_end)}
            </span>
          </h1>
          {data.map((result, index) => (
            <div key={index} className='flex flex-col w-full gap-2.5 p-3'>
              <div className='flex items-center justify-between gap-3 w-full'>
                <div className='flex flex-col w-[60%]'>
                  <p className='text-sm text-[#78787D]'>Criteria</p>
                  <p className='text-[#78787D] p-2 rounded-md text-sm bg-[#EAEDF2]'>
                    {result.name}
                  </p>
                </div>
                <div className='flex flex-col w-[20%]'>
                  <p className='text-sm text-[#78787D]'>Max Grade</p>
                  <p className='text-[#78787D] p-2 rounded-md text-sm bg-[#EAEDF2]'>
                    {result.max_grade}
                  </p>
                </div>
                <div className='flex flex-col w-[20%]'>
                  <p className='text-sm text-[#78787D]'>Grade</p>
                  <p className='text-[#78787D] p-2 rounded-md text-sm bg-[#EAEDF2]'>
                    {result.grade}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </>
  )
}

export default ViewPerformance
